import React from 'react';
import get_bundle from '../../domain/get_bundle';
import SponsorDomain from '../../domain/Sponsor';
import Layout from '../../components/Layout';
import ResendPasswordContent from '../../components/content/ResendPassword';
import ResendPasswordHeader from '../../components/header/ResendPassword';
import Sponsor from '../../components/Sponsor';
import t from 'tcomb-form';
import { props } from 'tcomb-react';

@props({
  locale: t.Obj,
  sponsor: t.maybe(SponsorDomain),
  goLogin: t.Func,
  doAcceptCookies: t.Func,
  doResendPassword: t.Func,
  message: t.maybe(t.ReactElement)
})
export default class ResendPassword extends React.Component {

  getHeader() {
    return (<ResendPasswordHeader
      goLogin={this.props.goLogin}
      goLoginLabel={get_bundle(this.props.locale).resend_password.go_login} />);
  }

  getSponsor() {
    const options = {
      showTutorial: false
    };
    return (<Sponsor locale={this.props.locale} options={options} />);
  }
  render() {
    return (
      <Layout header={this.getHeader()} sponsor={this.getSponsor()} locale={this.props.locale} doAcceptCookies={this.props.doAcceptCookies}>
        <ResendPasswordContent
          locale={this.props.locale}
          goLogin={this.props.goLogin}
          doAcceptCookies={this.props.doAcceptCookies}
          doResendPassword={this.props.doResendPassword}
          message={this.props.message}  />
      </Layout>
    );
  }
}



/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/user/route/ResendPassword.js
 **/